// The buy panel (shop/_buy_panel.html): a plain GET form to the checkout. Here only the
// running total and the button label follow the ticked add-ons - without JS it still works.
function euro(cents) {
  return Math.floor(cents / 100) + ',' + String(cents % 100).padStart(2, '0');
}

function initBuyPanel(panel) {
  const form = panel.querySelector('form');
  if (!form || panel.dataset.ready) return;
  panel.dataset.ready = '1';
  const total = panel.querySelector('[data-buy-total]');
  const button = panel.querySelector('[data-buy-button]');
  const update = () => {
    let cents = 0;
    panel.querySelectorAll('[data-always]').forEach((el) => { cents += Number(el.dataset.cents); });
    panel.querySelectorAll('input[type=checkbox]:checked').forEach((el) => { cents += Number(el.dataset.cents); });
    total.textContent = euro(cents);
    button.disabled = cents === 0;
    button.textContent = cents ? 'Weiter zur Kasse · ' + euro(cents) + ' €' : 'Wähle etwas aus';
  };
  form.addEventListener('change', update);
  update();
}

function scan() {
  document.querySelectorAll('[data-buy-panel]').forEach(initBuyPanel);
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
else scan();
// the book page may draw the panel later (polling / morphing)
new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
